module.exports = __webpack_public_path__ + "static/media/c1_2.ba916b78.png";